export default [
  {
    path: '/farms',
    name: 'Farms-list',
    component: () => import('@/components/adm/farms/FarmsList.vue'),
    meta: {
      title: "Cadastro > Propriedades"
    }
  }
]